import { db } from '@/shared/lib/db'
import { auth } from '@/shared/lib/firebase'
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'

// sign in with google

export const signInWithGoogle = async () => {
    const googleProvider = new GoogleAuthProvider()

    try {
        await signInWithPopup(auth, googleProvider)
    } catch (error) {
        console.error('Error signing in with Google', error)
    }
}

export function useSignout() {
    const navigate = useNavigate()
    const handleSignout = async () => {
        try {
            await signOut(auth)
            localStorage.removeItem('dbSynced')
            await Promise.all(db.tables.map((table) => table.clear()))
            navigate('/login', { replace: true })
        } catch (error) {
            console.error('signout error', error)
            throw new Error('failed to sign out')
        }
    }
    return handleSignout
}

export { auth }
